import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { GET_NO_OF_DOORS } from '../../Store/AssetManagement/NoOfDoors/NoOfDoorsType'
import { setNoOfDoors } from 'Store/AssetManagement/NoOfDoors/NoOfDoorsAction';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getNoOfDoors(req: any): any {

    let payloadData : IPayload= {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/vehicle/noofdoors/${req.val}`,
        payload : null
    }

    try {
        yield put(globalLoaderText("Fetching No Of Doors...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response?.length > 0) {
        const defaultNoOfDoorsOption = {
            text: "Select No Of Doors",
            value: null
        };
        response.unshift(defaultNoOfDoorsOption);
       }
        yield put(setNoOfDoors(response))

        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setNoOfDoors([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetNoOfDoors() {
    yield takeEvery(GET_NO_OF_DOORS, getNoOfDoors)
}

export default function* combinedSaga() {
    yield all([
        watchGetNoOfDoors()
    ])
}
